import { useQuery } from '@tanstack/react-query'
import { QueryCacheKeys } from '@/api/queryKeys.ts'
import { getCookie } from '@/util/cookie.ts'
import { KEY_ACCESS_TOKEN } from '@/store/LoginStore.ts'
import { API_ENDPOINT } from '@/constant/constant.ts'

// 위치 정보 인터페이스
export interface IUserPosition {
  order: number
  latitude: number
  longitude: number
  accuracy: number
  timestamp: string
}

// 회원의 오늘 위치 정보 조회 API
export const apiGetUserDailyPosition = async (userId: number) => {
  // 인증 토큰 확인
  const token = getCookie(KEY_ACCESS_TOKEN);
  
  try {
    // 엔드포인트 URL
    const url = `${API_ENDPOINT}/protectee/${userId}/daily-position`;
    
    // 직접 fetch 호출
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });
    
    // 응답 처리
    if (!response.ok) {
      throw new Error(`API 오류: ${response.status} ${response.statusText}`);
    }
    
    const result = await response.json();
    
    // API가 data 필드에 응답을 넣는 경우
    if (result.data !== undefined) {
      return { 
        data: result.data,
        code: result.code || 200,
        message: result.message || ''
      };
    }
    
    // API가 직접 배열을 반환하는 경우
    if (Array.isArray(result)) {
      return {
        data: result,
        code: 200,
        message: ''
      };
    }
    
    // 기타 응답 형식
    return {
      data: [],
      code: 200,
      message: 'API 응답 형식이 예상과 다릅니다.'
    };
  } catch (error) {
    throw error;
  }
}

// 위치 정보 쿼리 훅
const useQueryGetUserDailyPosition = (userId: number) => {
  return useQuery({
    enabled: userId > 0,
    queryKey: QueryCacheKeys.user.getUserDailyPosition(userId),
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    staleTime: 30000, // 30초간 캐시 유지
    queryFn: async () => {
      try {
        const response = await apiGetUserDailyPosition(userId);
        return Array.isArray(response.data) ? response.data : [];
      } catch (error) {
        return [];
      }
    }
  })
}

export default useQueryGetUserDailyPosition 